module.exports = __webpack_public_path__ + "img/5484c8d7fa086e16b1614fa979890840.png";